import React, { useState } from "react";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import { CreatorContentMonitor } from "src/types";
import { ReactComponent as EditIcon } from "src/images/edit.svg";
import { ReactComponent as TrashCanIcon } from "src/images/trash-can.svg";

interface Props {
  monitor: CreatorContentMonitor;
  openContentMonitoringDetails: (uuid: string) => void;
  toggleMonitorEnabled: (monitor: CreatorContentMonitor) => void;
  setElementToBeDeletedData: (monitor: CreatorContentMonitor) => void;
}

export const CreatorContentMonitoringListItem = (props: Props) => {
  const {
    monitor,
    openContentMonitoringDetails,
    toggleMonitorEnabled,
    setElementToBeDeletedData,
  } = props;

  const [loading, setLoading] = useState(false);

  const handleChangeSwitch = async () => {
    setLoading(true);
    await toggleMonitorEnabled(monitor);
    setLoading(false);
  };

  return (
    <div
      className="creator-content-monitoring-list__content-item"
      data-qa={monitor.name}
    >
      {monitor.name}
      <div className="creator-content-monitoring-list__content-item-buttons">
        <CustomSwitch
          checked={monitor.enabled}
          onChange={handleChangeSwitch}
          disabled={loading}
        />
        <EditIcon onClick={() => openContentMonitoringDetails(monitor.uuid)} />
        <TrashCanIcon onClick={() => setElementToBeDeletedData(monitor)} />
      </div>
    </div>
  );
};
